import { lazy, Suspense, type ComponentProps } from "react";
import type { MarkdownEditor as Editor } from "@/shared/ui/markdown-editor";
import { Skeleton } from "@/shared/ui/state";

// A Tiptap-szerkesztő (és mögötte a ProseMirror) a melléklet legnagyobb függősége — csak
// akkor töltődik le, amikor egy beküldő panel kinyílik, nem a melléklet indulásakor.
const MarkdownEditor = lazy(() =>
  import("@/shared/ui/markdown-editor").then((m) => ({ default: m.MarkdownEditor })),
);

/** A közös Markdown-szerkesztő lustán betöltve, a melléklet mezőcímke-stílusával — az olvasói
 *  beküldő űrlapok (tapasztalat, olvasnivaló) ezt használják, az admin a szinkron változatot. */
export function LazyMarkdownEditor(props: ComponentProps<typeof Editor>) {
  return (
    <Suspense fallback={<EditorSkeleton />}>
      <MarkdownEditor labelClassName="text-[13px] font-semibold text-ink" {...props} />
    </Suspense>
  );
}

/** A szerkesztő helye, amíg a kódja letöltődik: címke + eszköztár + mező sziluettje. */
function EditorSkeleton() {
  return (
    <div className="flex flex-col gap-2" role="status" aria-label="A szerkesztő betöltése">
      <Skeleton className="h-5 w-32" />
      <Skeleton className="h-9 w-56" />
      <Skeleton className="h-32 w-full" />
    </div>
  );
}
